export class BodyEncoder {
  private static instance: BodyEncoder;
  private encodingKey = 'your-encoding-key';

  static getInstance(): BodyEncoder {
    if (!BodyEncoder.instance) {
      BodyEncoder.instance = new BodyEncoder();
    }
    return BodyEncoder.instance;
  }

  encodeBody(
    operationName: string,
    timestamp: number,
    variables?: any,
  ): string {
    const data = {
      op: operationName,
      ts: timestamp,
      vars: variables || {},
      nonce: this.generateNonce(),
    };

    const jsonString = JSON.stringify(data);
    const encodedString = this.base64Encode(jsonString);

    const encoded = this.xorEncode(encodedString, this.encodingKey);

    return encoded;
  }

  private generateNonce(): string {
    return (
      Math.random().toString(36).substring(2, 15) +
      Math.random().toString(36).substring(2, 15)
    );
  }

  private xorEncode(input: string, key: string): string {
    let result = '';
    for (let i = 0; i < input.length; i++) {
      const charCode = input.charCodeAt(i) ^ key.charCodeAt(i % key.length);
      result += String.fromCharCode(charCode);
    }

    return this.base64Encode(result);
  }

  private base64Encode(input: string): string {
    const encoder = new TextEncoder();
    const encodedData = encoder.encode(input);
    const binaryString = String.fromCharCode(...encodedData);
    return btoa(binaryString);
  }
}

export const bodyEncoder = BodyEncoder.getInstance();
